// extracted by mini-css-extract-plugin
module.exports = {"container":"StandingOrderRadioButtonGroup_container__2BhiM","icons":"StandingOrderRadioButtonGroup_icons__1cYqW"};